import { render } from "./FormStatsCard.vue?vue&type=template&id=28f64b76&scoped=true&ts=true"
import script from "./FormStatsCard.vue?vue&type=script&lang=ts"
export * from "./FormStatsCard.vue?vue&type=script&lang=ts"

import "./FormStatsCard.vue?vue&type=style&index=0&id=28f64b76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f64b76"]])

export default __exports__